import { environment } from 'src/environments/environment';
import { IsFetchingAction, IsSendingAction } from './../store/common/common.actions';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { catchError } from '../../../node_modules/rxjs/operators';
import { tap } from 'rxjs/internal/operators/tap';
import { finalize } from 'rxjs/internal/operators/finalize';
import { SetErrorPageDataAction } from '../views/member-join/actions';

@Injectable()
export class HttpCustomInterceptor implements HttpInterceptor {
  private fetchRequests: HttpRequest<any>[] = [];
  private sendRequests: HttpRequest<any>[] = [];
  loadingSub: Subscription;

  isFetching = false;
  isSending = false;

  constructor(
    private store: Store<any>,
    public toastr: ToastrService
  ) {
  }

  showError(errors) {
    const toastr = this.toastr;
    errors.forEach(function (element) {
      toastr.error(element);
    });
  }

  removeFetchRequest(req: HttpRequest<any>) {
    this.fetchRequests = this.fetchRequests
      .filter((x) => x.method === req.method)
      .filter((x) => x.url !== req.url);
    var hasValue = this.fetchRequests.length > 0;

    // we want the page to get a loading indicator when fetching resources
    if (this.isFetching != hasValue) {
      this.isFetching = hasValue;
      this.store.dispatch(IsFetchingAction({ payload: this.isFetching }));
    }

  }

  removeSendRequest(req: HttpRequest<any>) {
    this.sendRequests = this.sendRequests
      .filter((x) => x.method === req.method)
      .filter((x) => x.url !== req.url);
    var hasValue = this.sendRequests.length > 0;

    // we want buttons to show loading indicators is sending data to API
    if (this.isSending != hasValue) {
      this.isSending = hasValue;
      this.store.dispatch(IsSendingAction({ payload: this.isSending }));
    }

  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      !request.url.endsWith('.json') &&
      request.url.startsWith(environment.apiUrl)
    ) {
      var exist = this.fetchRequests.filter((x) => {
        return x.url == request.url;
      });
      if (exist.length == 0) {
        if (request.method === "GET") {
          this.fetchRequests.push(request);

          // we want the page to get a loading indicator when fetching resources
          if (request.method === 'GET' && !this.isFetching) {
            this.isFetching = true;
            this.store.dispatch(IsFetchingAction({ payload: true }));
          }
        }
        else {
          this.sendRequests.push(request);

          // we want buttons to show loading indicators is sending data to API
          if (request.method !== 'GET' && !this.isSending) {
            this.isSending = true;
            this.store.dispatch(IsSendingAction({ payload: true }));
          }
        }
      }
    }

    const authReq = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + window.sessionStorage.getItem('token_name')
      }
    });

    return next.handle(authReq).pipe(
      tap((_event: HttpEvent<any>) => { }),
      finalize(() => {
        if (request.method === "GET") {
          this.removeFetchRequest(request);
        }
        else {
          this.removeSendRequest(request);
        }
      }),
      catchError((error, _caught) => {
        if (request.method === "GET") {
          this.removeFetchRequest(request);
        }
        else {
          this.removeSendRequest(request);
        }

        if (error.error && error.error.message) {
          if (error.error.displayErrorPage == true) {
            setTimeout(() => {
              this.store.dispatch(
                SetErrorPageDataAction({ data: error.error })
              );
            }, 0);
          } else {
            this.showError([error.error.message]);
          }
        }
        return throwError(() => error);
      }) as any
    );
  }
}
